module.exports = __webpack_public_path__ + "img/doorLogo6.bb20af88.png";